import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle`
  #root {
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    font-synthesis: none !important;
  }
`;
